import { withRailsContext } from '../RailsContext';
import ContractorProfile from '../contractors/profile';

export default withRailsContext(ContractorProfile);
